<template>
  <div>
    <a-card :bordered="false">
      <div class="increase-edit-padding">
        <a-spin :spinning="loading">
          <a-skeleton v-show="loading" :paragraph="{rows: 10}" />
        </a-spin>
        <div v-show="!loading">
          <h2>Department Info</h2>
          <!-- 表单 -->
          <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
            <!-- 名称 -->
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="Dept Name"
              hasFeedback
            >
              <a-input
                placeholder="Dept Name"
                v-decorator="[
                  'name',
                  {rules: [{ required: true, message: 'Please input Dept Name.' }]}
                ]"
              ></a-input>
            </a-form-item>
            <!-- 父部门 -->
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="Parent Dept"
              hasFeedback
            >
              <a-select
                v-decorator="[
                  'parentId'
                ]"
              >
                <a-select-option :value="''">No Select</a-select-option>
                <a-select-option v-for="dept in allDeptList" :key="dept.id" :value="dept.id">{{ dept.name }}</a-select-option>
              </a-select>
            </a-form-item>
            <!-- 隐藏域 -->
            <a-form-item v-show="false"><a-input v-decorator="['id']"/></a-form-item>
          </a-form>
        </div>
      </div>
    </a-card>
    <a-card :bordered="false" style="margin-top: 20px;">
      <DeptPositionList v-if="!createFlag" :departmentId="record.id"></DeptPositionList>
    </a-card>
    <footer-tool-bar>
      <a-button type="primary" html-type="submit" :loading="saving" @click="handleSubmit">Save</a-button>
      <a-button style="margin-left: 8px;" :loading="saving" @click="handleGoBack">Cancel</a-button>
    </footer-tool-bar>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import DepartmentApi from '@/api/adm/api-department'
import DeptPositionList from './position/DeptPositionList'
import FooterToolBar from '@/components/FooterToolbar'

export default {
  name: 'DepartmentEdit',
  components: {
    DeptPositionList,
    FooterToolBar
  },
  props: {
    record: {
      type: [String, Object],
      default: null
    }
  },
  data () {
    return {
      saving: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      createFlag: false,
      // 所有部门列表
      allDeptList: null,
      // 加载中
      loading: true
    }
  },
  mounted () {
    this.initData(this.record)
  },
  methods: {
    async initData (data) {
      this.loading = true
      const res = await this.loadAllDeptList()
      var allDeptList = res.data.datas
      var formData = null
      var createFlag = true
      if (data === '') {
        // 新增
        formData = { 'id': null, 'name': null, parentId: '' }
      } else {
        createFlag = false
        // 编辑
        formData = pick(data, ['id', 'name', 'parentId'])
        formData.parentId = formData.parentId == null ? '' : formData.parentId
        // 如果是更新，就要从父部门列表中过滤掉自己
        if (allDeptList != null && allDeptList.length > 0) {
          allDeptList = allDeptList.filter(e => {
            return e.id !== formData.id
          })
        }
      }
      this.createFlag = createFlag
      this.editForm.setFieldsValue(formData)
      this.allDeptList = allDeptList
      this.loading = false
    },
    loadAllDeptList () {
      return DepartmentApi.query(Object.assign({ curPage: 1, pageSize: 1000 }, {}))
    },
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleSubmit (e) {
      e.preventDefault()
      this.saving = true
      // eslint-disable-next-line
      this.editForm.validateFields((err, fieldsValue) => {
        // 如果校验失败直接返回
        if (err) {
          return
        }
        var formData = this.editForm.getFieldsValue()
        formData.parentId = formData.parentId === '' ? null : formData.parentId
        // 添加
        if (formData.id === null) {
          DepartmentApi.add(formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Save successfully !')
              this.saving = false
              this.handleGoBack()
            }
          })
        }
        // 修改
        if (formData.id !== null) {
          DepartmentApi.update(formData.id, formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Update successfully !')
              this.saving = false
              this.handleGoBack()
            }
          })
        }
      })
    }
  }
}
</script>
